<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M10 2.1625C7.92208 2.16482 5.92992 2.99129 4.46061 4.46061C2.99129 5.92992 2.16482 7.92208 2.1625 10C2.16482 12.0779 2.99129 14.0701 4.46061 15.5394C5.92992 17.0087 7.92208 17.8352 10 17.8375C12.0779 17.8352 14.0701 17.0087 15.5394 15.5394C17.0087 14.0701 17.8352 12.0779 17.8375 10C17.8352 7.92208 17.0087 5.92992 15.5394 4.46061C14.0701 2.99129 12.0779 2.16482 10 2.1625V2.1625ZM10 20C4.48625 20 0 15.5137 0 10C0 4.48625 4.48625 0 10 0C15.5137 0 20 4.48625 20 10C20 15.5137 15.5137 20 10 20Z"
    ></path>
    <path
      d="M3.27125 5.09624L5.09625 3.27124L16.7287 14.9037L14.9037 16.7287L3.27125 5.09624Z"
    ></path>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'CancelSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
